// actions/timetableActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getTimetable = (params) => async (dispatch) => {
  try {
    dispatch({ type: "TIMETABLE_REQUEST" });
    const { data } = await api.get("/timetable", { params });
    dispatch({ type: "GET_TIMETABLE_SUCCESS", payload: data.timetable });
  } catch (err) {
    dispatch({ type: "TIMETABLE_FAIL", payload: err.response?.data?.message });
  }
};

// Fetch which periods are already taken for a class/section/day, and
// (optionally) which periods a specific teacher is already booked for
// on that day, so the UI can show availability before saving.
export const getTimetableAvailability = (params) => async () => {
  const { data } = await api.get("/timetable/availability", { params });
  return data;
};

export const createTimetableEntry = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "TIMETABLE_REQUEST" });
    const { data } = await api.post("/timetable", payload);
    dispatch({ type: "CREATE_TIMETABLE_SUCCESS", payload: data.entry });
  } catch (err) {
    dispatch({ type: "TIMETABLE_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const deleteTimetableEntry = (id) => async (dispatch) => {
  try {
    await api.delete(`/timetable/${id}`);
    dispatch({ type: "DELETE_TIMETABLE_SUCCESS", payload: id });
  } catch (err) {
    dispatch({ type: "TIMETABLE_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};
